var map = {
	"./admin_portal/board_permissions_controller.ts": 319,
	"./admin_portal/post_articles_controller.ts": 320,
	"./admin_portal/private_articles_controller.ts": 321,
	"./admin_portal/update_articles_controller.ts": 322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 318;